export default "__VITE_ASSET__ad31eb4a__"